import React, { useState } from "react";
import { classNames } from "../../helpers/classNames";

const NewTabs = ({ data, tabActions = () => { } }) => {
  const tabs = data;
  const [activeTab, setActiveTab] = useState(tabs[0]?.id);
  const activeTabData = tabs.find((tab) => tab.id === activeTab);

  return (
    <div className="w-full mx-auto">
      <div className="flex items-center md:justify-between -mb-px flex-col-reverse md:flex-row">
        <div className="flex overflow-hidden shadow shadow-md-pink/20 rounded-t-lg divide-x divide-md-pink/10 w-full md:w-auto">
          {tabs.map((tab, index) => {
            const isActive = activeTab === tab?.id;
            return (
              <button
                type="button"
                key={index}
                className={classNames(
                  "w-full md:w-auto flex flex-col items-center justify-center gap-1 py-3 px-3 sm:py-4 sm:px-6 min-w-28 cursor-pointer transition-all duration-300 border-b-2",
                  isActive ? "bg-white shadow-sm border-transparent text-md-pink" : "text-slate-600 hover:text-md-pink/50 bg-md-pink/5 hover:bg-md-pink/15 border-md-pink/15"
                )}
                onClick={() => setActiveTab(tab?.id)}
              >
                <i className={classNames("fa-fw text-3xl sm:text-4xl", tab?.icon)}></i>
                <span className={classNames("text-sm sm:text-base font-medium !leading-none")}>{tab?.label}</span>
              </button>
            );
          })}
        </div>
        {activeTabData?.tabActions && activeTabData.tabActions()}
      </div>
      <div className="relative z-[1] px-4 sm:px-6 py-4 sm:py-6 bg-white shadow shadow-md-pink/20 rounded-lg rounded-tl-none rounded-tr-none sm:rounded-tr-lg">{activeTabData?.content}</div>
    </div>
  );
};

export default NewTabs;
